import { typeAutocompleteComponent, typeAutocompleteTypes } from './dhl-form-shared-types';

export class DhlFormControlAutocomplete {
    component: typeAutocompleteComponent;
    type: typeAutocompleteTypes;
    name: string;
    label: string;
    required: string;
    validation: string[];
    placeHolder: string;
    defaultValue: any;
    cols: string[];
    options: string[];
    primaryText: string[];
    responseListName: string;
    secondaryText: string[];
    matIcon: string;
    apiUrl: string;
    minSearchChar: number;
    events:any; 
    urlType: string;
    urlTokenName: string;
    urlTokenValue: string;
    qparams:any;
    allowedResultTypes: string[];
    isSearchApi:any;

    constructor(data){
        this.component = data.component;
        this.apiUrl = data.apiUrl;
        this.name = data.name;
        this.events = data.events;
        this.primaryText = data.primaryText;
        this.responseListName = data.responseListName;
        this.cols = data.cols;
        this.defaultValue = data.defaultValue;
        this.matIcon = data.matIcon;
        this.label = data.label;
        this.secondaryText = data.secondaryText;
        this.required = data.required;
        this.options = data.options;
        this.placeHolder = data.placeHolder;
        this.type = data.type;
        this.validation = data.validation;
        this.minSearchChar = data.minSearchChar;
        this.urlType = data.urlType;
        this.urlTokenName = data.urlTokenName;
        this.urlTokenValue = data.urlTokenValue;
        this.qparams = data.qparams;
        this.allowedResultTypes = data.allowedResultTypes;
        this.isSearchApi = data.isSearchApi;
    }
}